import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'json',
  version: '1.0.0',
  properties: [
    {
      key: 'operation',
      label: 'Operation',
      type: 'options',
      required: true,
      default: 'parse',
      options: [
        { value: 'parse', name: 'Parse JSON' },
        { value: 'stringify', name: 'Convert to JSON String' },
      ],
      description: 'The JSON operation to perform',
    },
    {
      key: 'input',
      label: 'JSON String',
      type: 'string',
      required: true,
      placeholder: '{{ $node["NodeName"].string }}',
      description: 'The JSON string to parse into an object',
      displayOptions: {
        show: {
          operation: ['parse'],
        },
      },
    },
    {
      key: 'data',
      label: 'Data',
      type: 'string',
      required: true,
      placeholder: '{{ $node["NodeName"].object }}',
      description: 'The data to convert to a JSON string',
      displayOptions: {
        show: {
          operation: ['stringify'],
        },
      },
    },
    {
      key: 'pretty',
      label: 'Pretty Print',
      type: 'boolean',
      required: false,
      default: false,
      description: 'Format the output with indentation for readability',
      displayOptions: {
        show: {
          operation: ['stringify'],
        },
      },
    },
  ],
};

export default schema;
